import React from 'react';
import { Shortcut } from 'src/components/Shortcut/Shortcut';
import AppointmentSection from './components/AppointmentSection';
import { DataSection } from './components/DataSection/DataSection';
import DentalIQ from './components/DentalIQ';
import Greeting from './components/Greeting';
import { RecommendationSection } from './components/RecommendationSection/RecommendationSection';
import { SupplementaryInsuranceSection } from './components/SupplementaryInsuranceSection/SupplementaryInsuranceSection';
import { Warnings } from './components/Warnings/Warnings';
import * as S from './Dashboard.styles';
const Dashboard = ({
  person,
  personSummary,
  appointments,
  isLoading,
  recommendations,
  supplementaryInsurance
}) => {
  const {
    appointmentBundlesLoading,
    personLoading,
    otherRecommendationsLoading,
    dentalRecommendationsLoading
  } = isLoading;
  const showRecommendations = !(otherRecommendationsLoading || dentalRecommendationsLoading) && (recommendations.dental.length > 0 || recommendations.other.length > 0);
  const showData = personSummary?.hasImages || personSummary?.hasJawFindings || personSummary?.hasPatientHistory || personSummary?.hasPsiDiagnosis;
  return /*#__PURE__*/React.createElement(S.Root, null, /*#__PURE__*/React.createElement(Warnings, null), /*#__PURE__*/React.createElement(Greeting, {
    person: person
  }), /*#__PURE__*/React.createElement(DentalIQ, null), /*#__PURE__*/React.createElement(AppointmentSection, {
    appointments: appointments,
    processing: appointmentBundlesLoading || personLoading
  }), showRecommendations && /*#__PURE__*/React.createElement(RecommendationSection, {
    recommendations: recommendations,
    processing: otherRecommendationsLoading || dentalRecommendationsLoading
  }), supplementaryInsurance.quotable && !supplementaryInsurance.dismissed && /*#__PURE__*/React.createElement(SupplementaryInsuranceSection, null), showData && /*#__PURE__*/React.createElement(DataSection, {
    summary: personSummary
  }), /*#__PURE__*/React.createElement(Shortcut, null));
};
export default Dashboard;